export default __webpack_public_path__ + "static/media/flamebarrage.920965e1.png";